import { BuiltInComponents } from 'craft/constants';
import {
  CssSelectorId,
  CustomNodeData,
  getCssSelectorDefinition,
  MediaBreakpoint,
} from 'craft/types';

const displayTypes = {
  View: 'flex',
  [BuiltInComponents.Modal]: 'flex',
  [BuiltInComponents.Document]: 'flex',
  [BuiltInComponents.Columns]: 'grid',
};

const handleLg = (hidden: MediaBreakpoint[], css: object) => {
  if (!hidden.includes(MediaBreakpoint.LG)) {
    return css;
  }
  return {
    ...css,
    display: 'none',
  };
};

const handleSelector = (
  hidden: MediaBreakpoint[],
  cssSelectors: object = {},
  viewport: MediaBreakpoint,
  selector: CssSelectorId,
  defaultDisplay: string,
) => {
  const cssSelectorDefiniton = getCssSelectorDefinition(selector);
  let css = {
    display: defaultDisplay,
    // @ts-ignore
    ...((cssSelectors[selector] ?? {}).css ?? {}),
  };
  if (hidden.includes(viewport)) {
    css = { ...css, display: 'none' };
  }
  const cssSelector = {
    ...cssSelectorDefiniton,
    // @ts-ignore
    ...(cssSelectors[selector] ?? {}),
    css,
  };
  return { ...cssSelectors, [selector]: cssSelector };
};

export const migrateMediaHiddenSelectors = (
  custom: CustomNodeData,
  type: string,
): CustomNodeData => {
  const { css = {}, media, cssSelectors = {}, ...otherCustom } = custom ?? {};
  const { hidden, ...otherMedia } = media ?? {};
  if (!hidden || hidden.length === 0) {
    return custom;
  }
  // @ts-expect-error
  const defaultDisplay = displayTypes[type] || 'block';
  const sm = handleSelector(
    hidden,
    cssSelectors,
    MediaBreakpoint.SM,
    CssSelectorId.RootSM,
    defaultDisplay,
  );
  const md = handleSelector(hidden, sm, MediaBreakpoint.MD, CssSelectorId.RootMD, defaultDisplay);
  return {
    ...otherCustom,
    // @ts-ignore
    media: otherMedia,
    css: handleLg(hidden, css),
    // @ts-ignore
    cssSelectors: md,
  };
};
